<script setup lang="ts">
import { getAriaIDs } from './inputHelper'

export type RadioGroupProps = {
  name: string
  label: string
  hint?: string
  error?: string
  attempt?: number
}

const props = defineProps<RadioGroupProps>()
const ariaIds = getAriaIDs(props)
const emit = defineEmits(['select'])
</script>

<template>
  <fieldset class="radio-group" :class="{ 'input--error': error }" :aria-describedby="ariaIds" :aria-invalid="!!error">
    <legend>
      <slot name="legend">
        <span class="sr-only">{{ label }}</span>
      </slot>
    </legend>
    <slot> <!-- <Radio> component (with custom attrs) goes here --></slot>
    <InputMessage :name="name" :error="error" :hint="hint" :attempt="attempt" />
  </fieldset>
</template>

<style lang="postcss">
.radio-group {
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
}
</style>
